(function () {
    'use strict';

    angular
        .module('app')
        .controller('carryoverForecasting', function carryoverForecasting($scope, $rootScope, $state, ForecastingService, toaster, CarryoverData, cfpLoadingBar) {
            var model = this;
            $scope.permissionDenied = function () {
                $state.go('permissionDenied');
            }

            $scope.goToUserPage = function (data) {
                $state.go(data.pageName, data.params);
            }

            $scope.loaderClosed = function () {
                cfpLoadingBar.complete();
            }

            $scope.loaderStart = function () {
                cfpLoadingBar.start();
            }
            angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                if (userPermissionRow[0] == 14) {
                    if (userPermissionRow[1] == 2) {
                        model.CarryoverEdit = true;
                    }
                }
            });

            if (!model.CarryoverEdit) {
                $state.go('permissionDenied');
            }

            model.coPrototypes = [];
            model.tempcoPrototypes = [];

            if (CarryoverData.data) {
                model.coPrototypes = CarryoverData.data; //.slice();
            }

            $scope.regions = [
                { id: 'US', name: 'US' },
                { id: 'CAN', name: 'Canada' },
                { id: 'UK', name: 'UK' },
                { id: 'EU', name: 'EU' },
                { id: 'DTC', name: 'DTC' },
                { id: 'INTL', name: 'International' },
                { id: 'ALL', name: 'All Regions' }
            ];

            var globalBrandUserPreferenceId = 0;
            var globalSeasonUserPreferenceId = 0;
            var globalPageNumber = 1;
            var globalPageSize = 50;
            var globalSortColumn = "";
            var globalSortDirection = "";

            $scope.doSave = function (params) {
                $scope.calcTotalVolumes(params);
                $scope.saveEdits(params.data);
            };

            function parseVolume(volumeVal) {
                if (volumeVal == NaN || volumeVal == null) {
                    volumeVal = 0;
                }
                else if (volumeVal.toString().trim() == "") {
                    volumeVal = 0;
                }

                return parseFloat(volumeVal);
            };

            $scope.calcTotalVolumes = function (params) {
                //cols
                var colName1 = 'TotalVolume',
                    colName2 = 'IntnlVolume';

                var IntlVolume = parseVolume(params.data.AsiaVolume) +
                    parseVolume(params.data.Emea3pVolume) +
                    parseVolume(params.data.LatinAVolume);

                var TotVolume = parseVolume(params.data.USVolume) +
                    parseVolume(params.data.NaDtcStoreVolume) +
                    parseVolume(params.data.NaDtcEcomVolume) +
                    parseVolume(params.data.CAVolume) +
                    parseVolume(params.data.EmeaOwnedVolume) +
                    parseVolume(params.data.EmeaDistVolume) +
                    parseVolume(params.data.EuDtcVolume) +
                    IntlVolume;

                var rowNode = gridOptions.api.getRowNode(params.node.data.PrototypeSeasonalId);
                rowNode.setDataValue(colName1, TotVolume);
                rowNode.setDataValue(colName2, IntlVolume);
            }

            $scope.pagingOptions = [15, 25, 50, 100];

            $scope.onBtnBeg = function () {
                $scope.pageNumber = 1;
                $scope.onPageChanged(1);
            }

            $scope.onBtnEnd = function () {
                $scope.pageNumber = $scope.totalPages;
                $scope.onPageChanged($scope.totalPages);
            }

            $scope.onBtnPrev = function (e) {
                if (e > 1) {
                    e = e - 1;
                    $scope.pageNumber = e;
                    $scope.onPageChanged(e);
                }
            }

            $scope.onBtnNext = function (e) {
                if (e < $scope.totalPages) {
                    e = e + 1;
                    $scope.pageNumber = e;
                    $scope.onPageChanged(e);
                }
            }

            $scope.onPageChanged = function (e) {
                globalPageNumber = e;
                $scope.getForecast($scope.searchForm);
            }

            $scope.onPageSizeChanged = function (e) {
                globalPageSize = e;
                globalPageNumber = 1;
                $scope.getForecast($scope.searchForm);
            }

            $scope.windowGridHeight = function () {
                if (window.outerHeight >= 768) {
                    return window.innerHeight - 315;
                } else {
                    var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                    return (size * gridOptions.rowHeight) + 46;
                }
            }

            function valueConvert(n) {
                if (n !== '' && n !== null && n !== true && n !== false) {
                    if (!isNaN(n)) {
                        return parseInt(n);
                    }
                }
                if (n == null || n == '') {
                    return '';
                }
                return n;
            }

            //define custom editor class
            function customCellEditor() {
            }

            customCellEditor.prototype.init = function (params) {
                this.params = params;
                this.eInput = document.createElement('input');
                this.eInput.className = 'ag-cell-edit-input';
                this.eInput.maxLength = '8'; //set maxlength for editing db is an INT so go nuts
                this.eInput.type = 'text';

                //assignment back from API changes or a direct input change
                if (params.charPress) {
                    var number = parseInt(params.charPress);
                    if (!isNaN(number))
                        this.eInput.value = params.charPress;
                } else {
                    this.eInput.value = params.value;
                }

                this.eInput.addEventListener('keydown', function (event) {
                    var value = this.value;
                    //backspace, tab, up, down, left, right arrows, enter, period, period_num_pad, Ctrl, Ctrl+A,Ctrl+C,Ctrl+V,Ctrl+X,
                    var allowedKeys = [8, 13, 37, 38, 39, 40, 46, /*190, 110,*/ 17, 65, 86, 67, 88, 116, 82];
                    var isThisLaunch = false;
                    if (params.column.colId == 'Launch') {
                        isThisLaunch = true;
                    }
                    var eventKey = event.key;

                    //no spacebar
                    if (eventKey == " ") {
                        eventKey = 'x';
                        //just defaulting it to a value that isnt allowed
                    }

                    if (isNaN(eventKey)) {
                        //if one of the keys in the array above is pressed, no nothing
                        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Command+A
                        if (allowedKeys.indexOf(event.keyCode) == -1 && (event.ctrlKey !== true || event.metaKey !== true)) {
                            event.preventDefault();
                        }
                    } else {
                        var ek = event.key;
                        var pf = parseFloat(value + ek);
                        if (isThisLaunch && (pf > 8 || pf < 1)) {
                            event.preventDefault();
                        }
                    }
                });
            }

            customCellEditor.prototype.getGui = function () {
                return this.eInput;
            };

            // focus and select can be done after the gui is attached
            customCellEditor.prototype.afterGuiAttached = function () {
                var l = this.eInput.value ? this.eInput.value.toString().length : '';

                this.eInput.value = this.eInput.value;

                if (!this.params.charPress) {
                    this.eInput.setSelectionRange(0, l);
                } else {
                    if (l !== "") {
                        this.eInput.setSelectionRange(l, l);
                    }
                }
                this.eInput.focus();
            };

            // returns the new value after editing
            customCellEditor.prototype.isCancelBeforeStart = function () {
                return this.cancelBeforeStart;
            };

            // returns the new value after editing
            customCellEditor.prototype.getValue = function () {
                return this.eInput.value;
            };

            function currency(params) {
                if (params && params.value) {
                    return '$' + params.value;
                } else {
                    return null;
                }
            }

            var widthXS = 65;
            var widthS = 105;
            var widthM = 160;
            var widthL = 210;
            var widthXL = 350;
            var globalRowHeight = 30;
            var widthImage = 76;

            //build gridoptions, build columns
            var gridOptions = {
                columnDefs: null,
                rowHeight: globalRowHeight,
                enableColResize: true,
                enableFilter: false,
                enableSorting: true,
                paginationPageSize: globalPageSize,
                suppressContextMenu: true,
                suppressMultiSort: true,
                suppressSorting: false,
                suppressDragLeaveHidesColumns: true,
                suppressMovableColumns: true, //set to false to stop from moving colums
                suppressRowHoverClass: true,
                suppressColumnMoveAnimation: true,
                showToolPanel: false,
                stopEditingWhenGridLosesFocus: true,
                getRowNodeId: function (data) { return data.PrototypeSeasonalId; },
                onSortChanged: function (e) {
                },
                onColumnVisible: function (e) {
                },
                onCellValueChanged: function (params) {
                    var oldValue = valueConvert(params.oldValue);
                    var newValue = valueConvert(params.newValue);

                    if (oldValue !== newValue && params.colDef.field !== 'IntnlVolume' && params.colDef.field !== 'TotalVolume') {
                        $scope.doSave(params);
                    }
                },
                onCellClicked: function (params) {
                    if (params.colDef.colorwayLink) {
                        $state.go('colorway', { 'prototypeSeasonalId': params.data.PrototypeSeasonalId });
                    }
                }
            };

            gridOptions.columnDefs = [
                { field: 'PrototypeSeasonalId', headerName: 'PSID', hide: true, editable: false, menuTabs: [] },
                { field: 'PrototypeId', headerName: 'PID', hide: true, editable: false, menuTabs: [] },
                { field: 'SeasonId', headerName: 'SeasonId', hide: true, editable: false, menuTabs: [] },
                { field: 'PrototypeName', headerName: 'Name', hide: false, suppressNavigable: true, editable: false, width: widthL, pinned: 'left', menuTabs: [], colorwayLink: true },
                { field: 'StockNum', headerName: 'Stock', hide: false, suppressNavigable: true, editable: false, width: widthS, pinned: 'left', menuTabs: [] },
                { field: 'StatusName', headerName: 'Status', hide: false, suppressNavigable: true, editable: false, width: widthS, pinned: 'left', menuTabs: [] },
                { field: 'Gender', headerName: 'Gender', hide: false, suppressNavigable: true, editable: false, width: widthS, pinned: 'left', menuTabs: [] },
                { field: 'FactName', headerName: 'Factory', hide: false, suppressNavigable: true, editable: false, width: widthL, pinned: 'left', menuTabs: [] },
                { field: 'CtryOfOrig', headerName: 'Origin', hide: false, suppressNavigable: true, editable: false, width: widthS, pinned: 'left', menuTabs: [] },
                { field: 'ColorDesc', headerName: 'Color', hide: false, suppressNavigable: true, editable: false, width: widthL, pinned: 'left', menuTabs: [] },
                { field: 'USVolume', headerName: 'US Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'NaDtcStoreVolume', headerName: 'NA DTC Store Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'NaDtcEcomVolume', headerName: 'NA DTC Ecom Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'CAVolume', headerName: 'CA Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'EmeaOwnedVolume', headerName: 'Emea Owned Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'EmeaDistVolume', headerName: 'EMEA Dist Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'EuDtcVolume', headerName: 'EU DTC Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'Emea3pVolume', headerName: 'EMEA 3P Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'ItalyVolume', headerName: 'Italy Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'AsiaVolume', headerName: 'Asia Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'CNVolume', headerName: 'CN Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'HKVolume', headerName: 'HK Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'C4CVolume', headerName: 'C4C Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'LatinAVolume', headerName: 'LatinA Vol', hide: false, editable: true, cellEditor: customCellEditor, width: widthS, menuTabs: [] },
                { field: 'IntnlVolume', headerName: 'Intl Vol', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', width: widthS, menuTabs: [] },
                { field: 'TotalVolume', headerName: 'Total Vol', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', width: widthS, menuTabs: [] },
                { field: 'ActPurPrice', headerName: 'Act Pur. $', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', cellRenderer: currency, width: widthS, menuTabs: [] },
                { field: 'EstPurPrice', headerName: 'Est Pur. $', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', cellRenderer: currency, width: widthS, menuTabs: [] }
                //missing                { field: 'RetailPrice', headerName: 'Retail $', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', cellRenderer: currency, width: widthS, menuTabs: [] },
                //missing                { field: 'WsPrice', headerName: 'WS $', hide: false, suppressNavigable: true, editable: false, cellClass: 'disabled', cellRenderer: currency, width: widthS, menuTabs: [] }
            ];

            $scope.saveEdits = function (rowEntity) {
                var fcast = {
                    PrototypeSeasonalId: rowEntity.PrototypeSeasonalId,
                    PrototypeId: rowEntity.PrototypeId,
                    PrototypeName: rowEntity.PrototypeName,
                    SeasonId: rowEntity.SeasonId,
                    SAPSeasonCode: rowEntity.SAPSeasonCode,
                    StatusName: rowEntity.StatusName,
                    Gender: rowEntity.Gender,
                    StockNum: rowEntity.StockNum,
                    FactName: rowEntity.FactName,
                    CtryOfOrig: rowEntity.CtryOfOrig,
                    ColorDesc: rowEntity.ColorDesc,
                    USVolume: rowEntity.USVolume,
                    NaDtcStoreVolume: rowEntity.NaDtcStoreVolume,
                    NaDtcEcomVolume: rowEntity.NaDtcEcomVolume,
                    ItalyVolume: rowEntity.ItalyVolume,
                    CAVolume: rowEntity.CAVolume,
                    EmeaOwnedVolume: rowEntity.EmeaOwnedVolume,
                    EmeaDistVolume: rowEntity.EmeaDistVolume,
                    EuDtcVolume: rowEntity.EuDtcVolume,
                    Emea3pVolume: rowEntity.Emea3pVolume,
                    AsiaVolume: rowEntity.AsiaVolume,
                    CNVolume: rowEntity.CNVolume,
                    HKVolume: rowEntity.HKVolume,
                    C4CVolume: rowEntity.C4CVolume,
                    LatinAVolume: rowEntity.LatinAVolume,
                    IntnlVolume: rowEntity.IntnlVolume,
                    TotalVolume: rowEntity.TotalVolume,
                    ActPurPrice: rowEntity.ActPurPrice,
                    EstPurPrice: rowEntity.EstPurPrice
                    //RetailPrice: rowEntity.RetailPrice,
                    //WsPrice: rowEntity.WsPrice
                    //Launch: rowEntity.Launch
                };

                //send the data object to the API
                ForecastingService.updateProtoForecast(fcast).then(function (response) {
                    //toaster.pop({
                    //    type: 'success',
                    //    title: 'Save complete!',
                    //    body: 'Row data successfully saved.',
                    //    timeout: 5000
                    //});

                }, function (response) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error performing the update: ' + response.data + ', ' + response.status,
                        timeout: 5000
                    });
                });
            };

            var FCols = [
                'USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume', 'ItalyVolume', 'CAVolume', 'EmeaOwnedVolume', 'EmeaDistVolume', 'EuDtcVolume', 'Emea3pVolume', 'AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume', 'IntnlVolume',
            ];

            $scope.columnsSet = function (arr, tf) {
                for (var i = 0; i < arr.length; i++) {
                    gridOptions.columnApi.setColumnVisible(arr[i], tf);
                }
            }

            $scope.setRegionVisibility = function (region) {
                $scope.region = region;
                switch (region) {
                    case "US":
                        $scope.columnsSet(FCols, false);
                        $scope.columnsSet(['USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume'], true);
                        break;
                    case "CAN":
                        $scope.columnsSet(FCols, false);
                        $scope.columnsSet(['CAVolume'], true);
                        break;
                    case "UK":
                        $scope.columnsSet(FCols, false);
                        $scope.columnsSet(['EmeaOwnedVolume'], true);
                        break;
                    case "EU":
                        $scope.columnsSet(FCols, false);
                        $scope.columnsSet(['EmeaDistVolume', 'EuDtcVolume', 'ItalyVolume'], true);
                        break;
                    case "INTL":
                        $scope.columnsSet(FCols, false);
                        $scope.columnsSet(['Emea3pVolume', 'AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume', 'IntnlVolume'], true);
                        break;
                    // case "LAUNCH":
                    //     $scope.columnsSet(FCols, false);
                    //     $scope.columnsSet(['Launch'], true);
                    //     break;
                    case "ALL":
                        $scope.columnsSet(FCols, true);
                        break;
                    default:
                        $scope.columnsSet(FCols, true);
                }
            };

            //getPage();

            function getPage() {
                if (model.coPrototypes) {
                    //$scope.totalRecords = model.coPrototypes[0].RecordCount;
                    $scope.totalRecords = model.coPrototypes.length
                    $scope.pageSize = globalPageSize;
                    $scope.pageNumber = globalPageNumber;
                    $scope.totalPages = Math.ceil($scope.totalRecords / globalPageSize);

                    $scope.lastRecord = $scope.pageNumber == $scope.totalPages ? $scope.totalRecords : $scope.pageNumber * $scope.pageSize;
                    $scope.firstRecord = $scope.pageNumber == $scope.totalPages ? (($scope.pageNumber - 1) * $scope.pageSize) + 1 : $scope.lastRecord - $scope.pageSize + 1;

                    var gridDiv = document.querySelector('#myGrid');

                    //if doesnt exist make new grid
                    //if does exist, set column defs
                    if (gridDiv.children.length == 0) {
                        new agGrid.Grid(gridDiv, gridOptions);
                    } else {
                        gridOptions.api.setColumnDefs(gridOptions.columnDefs);
                    }

                    //bind data to grid
                    gridOptions.api.setRowData(model.coPrototypes);


                    $scope.setRegionVisibility("US");

                    //show the grid, hide search form, mark page complete on load
                    $scope.showGrid = true;
                    //$scope.showSearchForm = false;
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No Forecasts Found',
                        timeout: 5000
                    });
                }
            };

            model.finish = function () {
                CarryoverData.reset();
                $state.go("carryover");
            }
        });
})();
